export default "__VITE_ASSET__DZJ6eQip__"